import { service } from "@/services/app.service";
import { formify } from "@/utils/helper.functions";
var BASE_URL = 'https://touchpoint.cardconnect.com';
var port = '443';
if (location.host.indexOf('localhost') === 0 || location.host.indexOf('tp-qa') !== -1 || location.host.indexOf('tp-devel') !== -1) {
    BASE_URL = 'https://touchpoint-uat.cardconnect.com';
    port = '6443';
}
export var PAYMENT_ENDPOINTS = {
    PAYMENT_ACTIONS: '/admin/squib_payment_account',
    TYPE_CC: {
        BASE_URL: BASE_URL,
        IFRAME: function () {
            var iframeCSS = "input{border: 1px solid #b5b5b5; padding: 5px; height: 20px; border-radius: 5px; width: 75%; font-size: 1rem; color: #363636;}.error{color: red;}body{margin-left: 0px;}input:focus{outline:none; box-shadow: 0 0 2px 1px #dddddd;}";
            return PAYMENT_ENDPOINTS.TYPE_CC.BASE_URL + ":" + port + "/itoke/ajax-tokenizer.html?tokenizewheninactive=false&invalidinputevent=true&autofocus=true&formatinput=true&enhancedresponse=true&css=" + encodeURIComponent(iframeCSS);
        }
    }
};
var paymentService = {
    addPaymentMethod: function (paymentReq) {
        return service.post(PAYMENT_ENDPOINTS.PAYMENT_ACTIONS, formify(paymentReq));
    },
    deletePaymentMethod: function (deletePaymentReq) {
        return service.post(PAYMENT_ENDPOINTS.PAYMENT_ACTIONS, formify(deletePaymentReq));
    },
    getPaymentAccount: function (accountReq) {
        return service.get(PAYMENT_ENDPOINTS.PAYMENT_ACTIONS + "?a=" + accountReq.a + "&c=" + accountReq.c + "&lb=" + accountReq.lb + "&b=" + accountReq.b);
    }
};
export default paymentService;



//////////////////
// WEBPACK FOOTER
// ./src/services/payment.service.ts
// module id = siIz
// module chunks = 18